import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalConfig} from '../../../model/modal-config';
import {PageNames} from '../../../shared/page-names.enum';
import {EmitterConstants} from '../../../shared/emitter-constants';
import {Emitter} from '../../../shared/utils/emitter/emitter';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {Trial} from '../../../model/trial';
import {Error} from '../../../model/error';

@Component({
  selector: 'app-trial-comparison',
  templateUrl: './trial-comparison.component.html',
  styleUrls: ['./trial-comparison.component.less']
})
export class TrialComparisonComponent implements AfterViewInit {
  @Input() config: ModalConfig;
  @Input() trials: Array<Trial>;
  @Output() emitClose = new EventEmitter<Object>();

  ownerComponent = PageNames.TRIAL_COMPARISON_MODAL;
  activationPending = false;

  chosenTrial: Trial = undefined;

  constructor(private navigationService: NavigationService) {
  }

  close(): void {
    Emitter.of(EmitterConstants.BACK_PRESSED).emit(PageNames.TRIAL_COMPARISON_MODAL);
  }

  ngAfterViewInit(): void {
    this.navigationService.resetNavigation();
  }

  public setActivationPending(isPending): void {
    this.activationPending = isPending;
  }

  public setTimeOut(isTimeout): void {
    if (isTimeout) {
      const timeoutError = new Error('timeout', 'There is no response. Please try again later.');
      Emitter.of(EmitterConstants.OPEN_TRIAL_ACTIVATION_TIMEOUT).emit({
        trial: this.chosenTrial,
        component: this.ownerComponent,
        error: timeoutError
      });
    }
  }

  setActivatedTrial($event: Trial) {
    this.chosenTrial = $event;
  }
}
